<nav class="navbar shadow-sm">
  <div class="container-fluid">

    <!-- ☰ Toggle Sidebar -->
    <button class="btn btn-link text-white fs-4 me-3" (click)="toggleSidebar()">
      <i class="bi bi-list"></i>
    </button>

    <!-- Logo -->
    <a class="navbar-brand text-white fw-bold" routerLink="/home" title="{{ licenciaDescripcion() }}">
      <i class="bi bi-bar-chart-line-fill"></i>

      <!-- corto para móvil -->
      <span class="brand-short">SIACI</span>

      <!-- largo para escritorio -->
      <span class="brand-long">{{ licenciaDescripcion() }}</span>
    </a>


    <!-- Usuario -->
    <div class="dropdown ms-auto">
      <button class="profile-trigger" type="button" data-bs-toggle="dropdown" aria-expanded="false">
        <span class="profile-trigger__user">
          <span class="profile-trigger__avatar">{{ initials() }}</span>
          <span class="username">{{ usuario() }}</span>
        </span>
        <i class="bi bi-three-dots-vertical"></i>
      </button>

      <div class="dropdown-menu dropdown-menu-end profile-menu shadow">
        <div class="profile-menu__card">
          <div class="profile-menu__top">
            <div class="profile-menu__avatar">{{ initials() }}</div>

            <div class="profile-menu__identity">
              <strong>{{ usuario() }}</strong>
              <span>Usuario del sistema</span>
            </div>
          </div>

          <div class="profile-menu__meta">
            <div class="profile-menu__meta-item">
              <span>Codigo</span>
              <strong>{{ usuarioId() }}</strong>
            </div>
            <div class="profile-menu__meta-item">
              <span>Estado</span>
              <strong>Activo</strong>
            </div>
          </div>

          <div class="profile-menu__actions">
            <button class="dropdown-item profile-action" type="button" (click)="goToProfile()">
              <i class="bi bi-person-lines-fill"></i>
              Ver perfil
            </button>
            <button class="dropdown-item profile-action profile-action--danger" (click)="logout()">
              <i class="bi bi-box-arrow-right"></i>
              Cerrar sesion
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</nav>
